<div class="w-full max-w-4xl">
    <mat-drawer-container class="flex-auto h-full bg-card dark:bg-transparent">
        <!-- Drawer -->
        <mat-drawer
            class="w-full md:w-160 dark:bg-gray-900"
            [mode]="drawerMode"
            [opened]="false"
            [position]="'end'"
            [disableClose]="true"
            #matDrawer
        >
            <router-outlet></router-outlet>
        </mat-drawer>
        <mat-drawer-content class="flex flex-col">
            <!-- Main -->
            <div class="flex-auto">
                <!-- Header -->
                <div id="header" class="flex flex-col sm:flex-row md:flex-col flex-auto justify-between py-8 px-6 md:px-8 border-b">
                    <!-- Title -->
                    <div>
                        <div class="text-4xl font-extrabold tracking-tight leading-none">
                            {{ 'label_registered_user' | translatePlural }}
                        </div>
                        <div class="ml-0.5 font-medium text-secondary">
                            {{ 'label_user_count' | translate: { count: usersCount } }}
                        </div>
                    </div>
                    <!-- Main actions -->
                    <div class="flex items-center mt-4 sm:mt-0 md:mt-4">
                        <!-- Search -->
                        <div class="flex-auto">
                            <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-full min-w-50">
                                <mat-icon class="icon-size-5" matPrefix [svgIcon]="'heroicons_solid:search'"></mat-icon>
                                <input
                                    matInput
                                    [formControl]="searchInputControl"
                                    [autocomplete]="'off'"
                                    [placeholder]="'Leita að kerfisnotanda'"
                                />
                            </mat-form-field>
                        </div>
                        <!-- Add contact button -->
                        <button class="ml-4" mat-flat-button [color]="'primary'" (click)="addServiceUser()">
                            <mat-icon [svgIcon]="'heroicons_outline:plus'"></mat-icon>
                            <span class="ml-2 mr-1 hidden md:block">{{ 'label_register' | translate }}</span>
                        </button>
                    </div>
                </div>
                <!-- Users list -->
                <div class="relative">
                    @if (users) {
                        @if (searchedUsers?.length != 0) {
                            @for (user of searchedUsers; track trackByFn(i, user); let i = $index) {
                                <!-- Group -->
                                @if (
                                    i === 0 ||
                                    user.username.charAt(0).toUpperCase() !== searchedUsers[i - 1].username.charAt(0).toUpperCase()
                                ) {
                                    <div
                                        class="z-10 sticky top-0 -mt-px px-6 py-1 md:px-8 border-t border-b font-medium uppercase text-secondary bg-gray-50 dark:bg-gray-900"
                                    >
                                        {{ user.username.charAt(0) }}
                                    </div>
                                }
                                <!-- User -->
                                <div class="flex items-center border-b px-6 md:px-8">
                                    <span
                                        class="z-20 flex grow items-center py-4 overflow-x-hidden cursor-pointer h:cursor-pointer"
                                        (click)="viewServiceUserDetails(user)"
                                    >
                                        <div class="flex flex-0 items-center justify-center w-10 h-10 rounded-full">
                                            <ng-container>
                                                <img class="object-cover w-full h-full" src="/assets/images/user/user.jpg" alt="Mynd" />
                                            </ng-container>
                                        </div>
                                        <div class="w-100 ml-4">
                                            <div class="font-medium leading-5 truncate">
                                                {{ user.username }}
                                            </div>
                                            <div class="flex flex-wrap sm:flex-nowrap">
                                                <span class="w-100 flex flex-row min-w-[250px]">
                                                    {{ user.domainName }}
                                                </span>
                                            </div>
                                        </div>
                                    </span>
                                    <div class="w-auto max-w-1/5">
                                        <button mat-icon-button (click)="DeleteServiceUser(user)" [matTooltip]="'Eyða kerfisnotanda'">
                                            <mat-icon class="icon-size-5 text-current" [svgIcon]="'heroicons_solid:trash'"></mat-icon>
                                        </button>
                                    </div>
                                </div>
                            }
                        }
                    }
                    <!-- No users -->
                    @if (hasHttpFetched && searchedUsers?.length == 0) {
                        <div class="p-8 sm:p-16 border-t text-4xl font-semibold tracking-tight text-center" #noUsers>
                            {{ 'info_no_user_found' | translatePlural }}
                        </div>
                    }
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>
